import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../../../services/layout.service';
import { ConfiguratorComponent } from '../configurator/configurator.component';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { LoggedUserStateService } from '../../../../services/logged-user-state.service';
import { AccessTokenService } from '../../../../services/access-token.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-topbar',
  imports: [
    RouterModule,
    CommonModule,
    StyleClassModule,
    ConfiguratorComponent,
    Menu,
    ButtonModule,
    RouterLink,
  ],
  templateUrl: './topbar.component.html',
  styles: `
    ::ng-deep{
      .user-menu > .p-menu {
        margin-top: 10px !important;
      }
    }
  `,
})
export class TopbarComponent {
  @Output() loading = new EventEmitter<boolean>();

  layoutService = inject(LayoutService);
  private loggedUserService = inject(LoggedUserStateService);
  private loggedUserStateService = inject(LoggedUserStateService);
  private router = inject(Router);
  private authService = inject(AuthService);
  private accessTokenService = inject(AccessTokenService);

  loggedUserFullname = this.loggedUserService.fullName;

  items!: MenuItem[];

  constructor() {
    this.items = [
      {
        label: 'Sair',
        icon: 'ph-duotone ph-sign-out',
        command: () => this.logOut(),
      },
    ];
  }

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({
      ...state,
      darkTheme: !state.darkTheme,
    }));
  }

  setLanguage(lang: string) {
    this.layoutService.layoutConfig.update((state) => ({
      ...state,
      language: lang,
    }));
  }

  isSelectedLanguage(lang: string) {
    return this.layoutService.layoutConfig().language === lang;
  }

  private logOut(): void {
    const token = this.accessTokenService.getAccessToken();
    if (!token) {
      this.loggedUserStateService.clear();
      this.accessTokenService.clearSession();
      this.router.navigate(['/auth/sign-in'], { replaceUrl: true });
      return;
    }
    this.loading.emit(true);

    this.authService
      .logOut({ token, tokenTypeHint: 'access_token' })
      .subscribe({
        complete: () => {
          this.loggedUserStateService.clear();
          this.accessTokenService.clearSession();

          if (this.router.url !== '/auth/sign-in') {
            this.router.navigate(['/auth/sign-in'], { replaceUrl: true });
          }
          this.loading.emit(false);
        },
        error: (e) => {
          this.loading.emit(false);
        },
      });
  }
}
